var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "alert alert-danger alert-dismissible fade show error-component",
      attrs: { role: "alert" }
    },
    [_vm._v("\n    " + _vm._s(_vm.message) + "\n    "), _vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a29ea26", { render: render, staticRenderFns: staticRenderFns })
  }
}